<template>

</template>


<script>
	import {mapState} from 'vuex';
	import AerisWeather from '@aerisweather/javascript-sdk';

	export default {
		name: 'Weather',
		data: function() {
			return {
				aeris: null
			}
		},
		computed: {
			...mapState([
				'location'
			]),
			current: {
				get() { return this.$store.state.weather.current },
				set(value) { this.$store.commit('setState', ['weather.current', value]) }
			},
			forecast: {
				get() { return this.$store.state.weather.forecast },
				set(value) { this.$store.commit('setState', ['weather.forecast', value]) }
			},
			alerts: {
				get() { return this.$store.state.weather.alerts },
				set(value) { this.$store.commit('setState', ['weather.alerts', value]) }
			},
			day: {
				get() { return this.$store.state.weather.day },
				set(value) { this.$store.commit('setState', ['weather.day', value]) }
			},
			map_img: {
				get() { return this.$store.state.weather.map_img },
				set(value) { this.$store.commit('setState', ['weather.map_img', value]) }
			}

		},
		watch: {
			time() {

			}
		},
		mounted() {
			this.aeris = new AerisWeather(this.$config.weather.access_id, this.$config.weather.secret_key);
			this.getCurrent();
			this.getForecast();
			this.getAlerts();
			this.getDay();
			this.getMapImg();
		},
		methods: {
			getCurrent() {
				this.aeris.api().endpoint('observations').place(this.location.lat+ ','+ this.location.long).get().then((result) => {
					var data = result.data.ob;
					this.current = data;
				});

			},
			getForecast() {
				this.aeris.api().endpoint('forecasts').place(this.location.lat+ ','+ this.location.long).limit(5).get().then((result) => {
					var data = result.data[0].periods;
					this.forecast = data;
				});
			},
			getAlerts() {
				this.aeris.api().endpoint('alerts').place(this.location.lat+ ','+ this.location.long).limit(5).get().then((result) => {
					var data = result.data;
					this.alerts = data;
				});
			},
			getDay() {
				this.aeris.api().endpoint('forecasts').place(this.location.lat+ ','+ this.location.long).filter('2h').limit(6).get().then((result) => {
					var data = result.data[0].periods;
					this.day = data;
				});
			},
			getMapImg() {
				// const request = this.aeris.map().layers('blue-marble,precip:50');
				// request.center(this.location.lat+ ','+ this.location.long).zoom(12);
				// request.size(400, 266);

				// request.get().then((result) => {
				// 	const { image, metadata: { validDate }} = result;
				// 	if (image) {
				// 		this.map_img = image.src;
				// 	}
				// });

			}
		}
	}
</script>
